// extracted by mini-css-extract-plugin
module.exports = {"title":"pitches_title__g14Ty","content":"pitches_content__3ZV9_","btn":"pitches_btn__2kHSP","introduction":"pitches_introduction__1wmHW","sending":"pitches_sending__1V0Wm"};